import mediaUrl from "../../utils/mediaUrl";
import React, { useEffect, useRef, useState } from "react";
import Footer from "../Footer";
import Header from "../Header";
import {
	faBookmark,
	faEnvelope,
	faFileAlt,
	faForward,
	faHeadphones,
	faLink,
	faLock,
	faPlay,
	faShare,
	faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import {
	faFacebookF,
	faLinkedinIn,
	faTwitter,
	faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { Navigate, useNavigate } from "react-router-dom";
import "../../assets/css/view_course.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { useParams } from "react-router-dom";
import auth from "../../utils/auth";
import track from "../../utils/track";
import axios from "axios";
import "@fontsource/cardo";
import { showToast } from "../../utils/toasts";
import { IonPage } from "@ionic/react";

const ViewCourse = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);
	const [selectedVideo, setSelectedVideo] = useState();
	const [like, setLike] = useState(false);
	const [save, setSave] = useState(false);
	const [shareCopied, setShareCopied] = useState(false);
	const [shareOpen, setShareOpen] = useState(false);
	const shareRef = useRef(null);
	const [langMenuOpen, setLangMenuOpen] = useState(false);
	const langRef = useRef(null);
	const [quiz, setQuiz] = useState(false);
	const [submitted, setSubmitted] = useState(false);
	const [quizSubmitted, setQuizSubmitted] = useState(false);
	const [lastVideo, setLastVideo] = useState(false);
	const [videos, setVideos] = useState([]);
	const [activeVideoUrl, setActiveVideoUrl] = useState("");
	const [likeCount, setLikeCount] = useState();
	const [activeVideoId, setActiveVideoId] = useState("");
	const [questions, setQuestions] = useState([]);
	const [selectedQuestion, setSelectedQuestion] = useState(0);
	const [selectedOption, setSelectedOption] = useState("");
	const [correctAns, setCorrectAns] = useState("");
	const [isCorrect, setIsCorrect] = useState(false);
	const [quizProgress, setQuizProgress] = useState([]);
	const [videoProgress, setVideoProgress] = useState([]);
	const [quizID, setQuizID] = useState("");
	const [resources, setResources] = useState([]);
	const [activeVideoDescription, setActiveVideoDescription] = useState("");
	const [langOptions, setLangOptions] = useState([]);
	const [selectedLang, setSelectedLang] = useState("English");
	const [urls, setUrls] = useState([]);
	const [activeVideoIndex, setActiveVideoIndex] = useState(0);
	const [course, setCourse] = useState({});
	const [refProgress, setRefProgress] = useState([]);
	const [showGrad, setShowGrad] = useState(false);
	const videoListRef = useRef(null);
	const [learnMode, setLearnMode] = useState("video");
	const [openStage, setOpenStage] = useState("learn");
	const [flashcards, setFlashcards] = useState([]);
	const [practiceIndex, setPracticeIndex] = useState(0);
	const [flipped, setFlipped] = useState(false);
	const [slideIndex, setSlideIndex] = useState(0);

	// Placeholder practice content until real practice questions are uploaded.
	const practiceQuestions = [
		{
			q: "List the five pillars of 5S in order.",
			a: "Sort, Set in Order, Shine, Standardize, Sustain.",
		},
		{
			q: "What is the 48-hour rule used for?",
			a: "Deciding whether an unused item should be removed from the immediate work area.",
		},
		{
			q: "Name one visual standard you could create in your work area.",
			a: "For example: shadow boards, floor markings, or labeled bins.",
		},
	];

	// Show the white fade only while more chapters remain below the fold.
	const updateChapterFade = () => {
		const el = videoListRef.current;
		if (!el) return;
		setShowGrad(el.scrollHeight - el.scrollTop - el.clientHeight > 20);
	};

	useEffect(() => {
		updateChapterFade();
	}, [videos, urls, openStage]);

	const params = useParams();
	let navigate = useNavigate();
	const config = {
		headers: {
			"Content-Type": "application/json",
			"x-auth-token": auth.getToken(),
		},
	};

	const handleSelectionClick = (video, key) => {
		setActiveVideoUrl(urls[key]);
		setActiveVideoIndex(key);
		setActiveVideoId(video._id);
		setActiveVideoDescription(video.description);
		setSlideIndex(0);
		track("chapter_play", { course: params.courseID, chapter: video._id });
		// console.log(video, activeVideoId);
		axios
			.get(`/chapters/${video._id}/getLikes`, config)
			.then((res) => {
				setLikeCount(res.data.count);
				setLike(res.data.hasUserLiked);
			})
			.catch((err) => console.log(err));
		setLastVideo(false);
	};

	// User-driven switch between video/audio/slides (engagement signal).
	const selectMode = (mode) => {
		setLearnMode(mode);
		track("mode_select", {
			course: params.courseID,
			chapter: activeVideoId,
			meta: { mode },
		});
	};

	const handleLike = () => {
		if (!activeVideoId) return;
		axios
			.get(`/chapters/${activeVideoId}/like`, config)
			.then((res) => {
				console.log("like-unlike****", res);
				if (like) {
					setLikeCount((prevState) => prevState - 1);
				} else {
					setLikeCount((prevState) => prevState + 1);
				}
				setLike(!like);
			})
			.catch((err) => console.log(err));
	};

	const shareUrl = `${window.location.origin}/courses/${params.courseID}`;
	const shareText = `Check out "${course?.name || "this course"}" on Wyden`;

	const shareTargets = [
		{
			name: "WhatsApp",
			icon: faWhatsapp,
			color: "#25D366",
			href: `https://wa.me/?text=${encodeURIComponent(
				`${shareText} ${shareUrl}`
			)}`,
		},
		{
			name: "LinkedIn",
			icon: faLinkedinIn,
			color: "#0A66C2",
			href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
				shareUrl
			)}`,
		},
		{
			name: "Facebook",
			icon: faFacebookF,
			color: "#1877F2",
			href: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
				shareUrl
			)}`,
		},
		{
			name: "X",
			icon: faTwitter,
			color: "#111111",
			href: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
				shareText
			)}&url=${encodeURIComponent(shareUrl)}`,
		},
		{
			name: "Email",
			icon: faEnvelope,
			color: "#293c74",
			href: `mailto:?subject=${encodeURIComponent(
				shareText
			)}&body=${encodeURIComponent(`${shareText}\n${shareUrl}`)}`,
		},
	];

	const copyShareLink = () => {
		const done = () => {
			setShareCopied(true);
			setTimeout(() => setShareCopied(false), 2000);
		};
		if (navigator.clipboard && navigator.clipboard.writeText) {
			navigator.clipboard.writeText(shareUrl).then(done).catch(done);
		} else {
			const ta = document.createElement("textarea");
			ta.value = shareUrl;
			document.body.appendChild(ta);
			ta.select();
			document.execCommand("copy");
			document.body.removeChild(ta);
			done();
		}
	};

	// Close the share popover on any click outside of it.
	useEffect(() => {
		if (!shareOpen) return;
		const onDocClick = (e) => {
			if (shareRef.current && !shareRef.current.contains(e.target)) {
				setShareOpen(false);
			}
		};
		document.addEventListener("mousedown", onDocClick);
		return () => document.removeEventListener("mousedown", onDocClick);
	}, [shareOpen]);

	// Close the in-player language menu on any click outside of it.
	useEffect(() => {
		if (!langMenuOpen) return;
		const onDocClick = (e) => {
			if (langRef.current && !langRef.current.contains(e.target)) {
				setLangMenuOpen(false);
			}
		};
		document.addEventListener("mousedown", onDocClick);
		return () => document.removeEventListener("mousedown", onDocClick);
	}, [langMenuOpen]);

	// Saved courses persist per user in localStorage (no backend endpoint yet).
	const savedKey = `savedCourses_${auth.getUserInfo()?._id}`;
	const handleSave = () => {
		const next = !save;
		setSave(next);
		try {
			const list = JSON.parse(localStorage.getItem(savedKey) || "[]");
			const updated = next
				? [...new Set([...list, params.courseID])]
				: list.filter((id) => id !== params.courseID);
			localStorage.setItem(savedKey, JSON.stringify(updated));
		} catch (_) {}
	};

	useEffect(() => {
		try {
			const list = JSON.parse(localStorage.getItem(savedKey) || "[]");
			if (list.includes(params.courseID)) setSave(true);
		} catch (_) {}
	}, []);

	// In-chapter resume: remember the playback position per chapter so the
	// learner picks up at the exact moment they left, even across sessions.
	const posKey = `resumePos_${params.courseID}`;
	const lastSavedSecond = useRef(-1);
	// Watch-depth heartbeat: highest 10%-bucket already reported per chapter, so
	// we emit at most ~10 fire-and-forget events across a full watch. Powers the
	// in-video retention / mid-chapter drop-off charts in Course Analytics.
	const lastHbBucket = useRef({});
	const savePlaybackPos = (e) => {
		const el = e.target;
		if (!activeVideoId || !el.duration) return;
		const second = Math.floor(el.currentTime);
		if (second === lastSavedSecond.current) return;
		lastSavedSecond.current = second;

		// Emit a heartbeat when the learner crosses into a new 10% depth bucket.
		const pct = Math.max(0, Math.min(100, Math.round((el.currentTime / el.duration) * 100)));
		const bucket = Math.floor(pct / 10) * 10;
		if (bucket > (lastHbBucket.current[activeVideoId] ?? -1)) {
			lastHbBucket.current[activeVideoId] = bucket;
			track("chapter_progress", {
				course: params.courseID,
				chapter: activeVideoId,
				meta: {
					seconds: second,
					duration: Math.floor(el.duration),
					pct,
					mode: learnMode,
				},
			});
		}

		try {
			const store = JSON.parse(localStorage.getItem(posKey) || "{}");
			// Near the end counts as watched — restart from 0 next time.
			const endGuard = Math.min(5, el.duration * 0.2);
			store[activeVideoId] =
				el.currentTime >= el.duration - endGuard ? 0 : el.currentTime;
			localStorage.setItem(posKey, JSON.stringify(store));
		} catch (_) {}
	};
	const restorePlaybackPos = (e) => {
		const el = e.target;
		try {
			const store = JSON.parse(localStorage.getItem(posKey) || "{}");
			const t = store[activeVideoId];
			const startGuard = Math.min(3, el.duration * 0.1);
			const endGuard = Math.min(5, el.duration * 0.2);
			if (t && t > startGuard && t < el.duration - endGuard) {
				el.currentTime = t;
			}
		} catch (_) {}
	};

	const handleNextQuestion = () => {
		setSubmitted(false);
		setSelectedQuestion((prevState) => prevState + 1);
		setIsCorrect(false);
		setCorrectAns("");
		setSelectedOption("");
		axios
			.get(`/progress/${params.courseID}/checkFinished`, config)
			.then((res) => {
				console.log(res.data);
				if (res.data.isQuizFinished) {
					setQuizSubmitted(true);
				}
			})
			.catch((err) => console.log(err));
	};

	// Placeholder reference material shown until real content is uploaded for a
	// course (resources API returns empty). Mirrors the approved design flow.
	const demoResources = [
		{
			isDemo: true,
			name: "A Comprehensive Compilation of the 5S System",
			description:
				"This document is a comprehensive compilation of the 5S workplace management system that covers topics from the history of 5S to the implementation of the system in detail. Many figures, diagrams, and tables are included to make the compilation more illustrative and descriptive.",
			ctaType: "Download",
		},
		{
			isDemo: true,
			name: "Industry Byte: Why training and development matters",
			description:
				"Today's business is ultra-competitive. Listen to the industry experts talk about the importance of 5S training that focuses on eliminating waste, and reducing costs, while also creating an environment that supports continuous business growth.",
			ctaType: "Watch Now",
		},
	];

	const displayResources = resources.length > 0 ? resources : demoResources;

	// Branded chapter-card posters shown in the sidebar until real chapter
	// videos (whose first frames are the branded slides) are uploaded.
	const chapterPosters = [
		"chapter_module.svg",
		"chapter_sort.svg",
		"chapter_set_in_order.svg",
		"chapter_shine.svg",
		"chapter_standardize.svg",
		"chapter_sustain.svg",
	];

	// Step-gated "Additional Reference Material": each resource unlocks after the
	// previous step (main videos -> resource 1 -> resource 2 -> ... -> quiz).
	// Consumption is remembered per course on this device.
	const refProgressKey = `refProgress_${params.courseID}`;

	const markResourceDone = (key) => {
		if (refProgress.includes(key)) return;
		const next = [...refProgress, key];
		setRefProgress(next);
		localStorage.setItem(refProgressKey, JSON.stringify(next));
	};

	const isVideosDone =
		lastVideo || (videos.length > 0 && videoProgress.length >= videos.length);

	const isResourceUnlocked = (key) => isVideosDone && refProgress.length >= key;

	const isQuizUnlocked =
		isVideosDone && refProgress.length >= displayResources.length;

	// Top-level stage tabs: Learn > Practice > Assess > Complete.
	const selectStage = (key) => {
		setOpenStage(key);
		if (key === "assess" && isQuizUnlocked) {
			setQuiz(true);
		} else {
			setQuiz(false);
		}
	};

	const resourceCta = (r) => {
		if (r.type === "download") return "Download";
		if (r.type === "watch") return "Watch Now";
		return (
			r.ctaType ||
			((r.url || "").toLowerCase().endsWith(".pdf") ? "Download" : "Watch Now")
		);
	};

	const nextStepLabel = (r) =>
		`${r.name}${resourceCta(r) === "Download" ? " - PDF" : ""}`;

	const handleNextStep = () => {
		document
			.getElementById("additional_reference")
			?.scrollIntoView({ behavior: "smooth" });
	};

	// Slides mode has no media timeline; completing it counts the chapter,
	// confirms it, and moves the learner on to the next unfinished chapter.
	const [markingComplete, setMarkingComplete] = useState(false);
	const markSlidesComplete = async () => {
		if (!activeVideoId || markingComplete) return;
		setMarkingComplete(true);
		const chapterProgress = await videoData(
			{ target: { duration: 1 } },
			activeVideoId
		);
		setMarkingComplete(false);
		if (!chapterProgress) {
			showToast("Couldn't save your progress — please try again", "error");
			return;
		}
		if (chapterProgress.length >= videos.length) {
			// Last chapter done — videoData already switched to the end screen.
			showToast("Chapter completed!", "success");
			return;
		}
		const done = chapterProgress.map(String);
		const nextIdx = videos.findIndex((v) => !done.includes(String(v._id)));
		if (nextIdx !== -1) {
			showToast("Chapter completed! Here's the next one", "success");
			handleSelectionClick(videos[nextIdx], nextIdx);
			window.scrollTo({ top: 0, behavior: "smooth" });
		}
	};

	const nextChapterIdx = videos.findIndex(
		(v) => !videoProgress.map(String).includes(String(v._id))
	);

	const goToNextChapter = () => {
		if (nextChapterIdx === -1) return;
		handleSelectionClick(videos[nextChapterIdx], nextChapterIdx);
		setOpenStage("learn");
		setLearnMode("video");
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const handleSubmit = (e, questionId) => {
		e.preventDefault();
		if (!selectedOption) {
			showToast("Please select an answer", "error");
			return;
		}
		setSubmitted(true);
		const body = {
			answer: selectedOption,
			courseID: params.courseID,
		};

		axios
			.post(`/progress/${questionId}/addQuestion`, body, config)
			.then((res) => {
				setIsCorrect(res.data.isCorrect);
				setCorrectAns(res.data.answer);
			})
			.catch((e) => {
				showToast(e.response?.data.message || "Something went wrong", "error");
			});
	};

	const videoData = async (e, videoID) => {
		try {
			const duration = e.target.duration;
			// Record the watch first, THEN read progress — running these in
			// parallel raced the GET against the POST and returned stale data.
			await axios.post(
				`/progress/${videoID}/addChapter`,
				{ timestamp: duration, totalLength: duration },
				config
			);
			const {
				data: { chapterProgress },
			} = await axios.get(`/progress/${params.courseID}`, config);

			setVideoProgress(chapterProgress);
			if (chapterProgress.length === videos.length) {
				setLastVideo(true);
			}
			return chapterProgress;
		} catch (error) {
			console.log(error);
			return null;
		}
	};

	const handleEnd = (e, videoID) => {
		videoData(e, videoID);
	};

	const handleLanguageChange = async (e) => {
		setSelectedLang(e.target.value);
		let videoUrls = [];
		await videos.map(async (v, key) => {
			await (v.media?.video || []).map((l, key2) => {
				if (l.language == e.target.value) {
					videoUrls.push(l.url);
				}
			});
		});
		setUrls(videoUrls);
		setActiveVideoUrl(videoUrls[activeVideoIndex]);
		setActiveVideoId(videos[activeVideoIndex]._id);
		setActiveVideoDescription(videos[activeVideoIndex].description);
	};

	const markFlashcardViewed = (id) => {
		axios
			.post(`/progress/${id}/addFlashcard`, {}, config)
			.catch((e) => console.log(e));
	};

	const fetchData = async () => {
		try {
			axios
				.get(`/flashcards/${params.courseID}`, config)
				.then((r) => setFlashcards(r.data.flashcards || []))
				.catch(() => {});

			const res = await axios.all([
				axios.get(`/chapters/${params.courseID}`, config),
				axios.get(`/quizzes/${params.courseID}`, config),
				axios.get(`/progress/${params.courseID}`, config),
				axios.get(`/resources/${params.courseID}`, config),
				axios.get(`/courses/${params.courseID}`, config),
			]);

			const [
				{
					data: { chapters: videos },
				},
				{
					data: { quiz },
				},
				{ data: progress },
				{ data: resources },
				{
					data: { course },
				},
			] = res;

			setCourse(course);
			try {
				setRefProgress(
					JSON.parse(localStorage.getItem(`refProgress_${params.courseID}`)) ||
						[]
				);
			} catch (e) {
				setRefProgress([]);
			}

			console.log(videos);
			let langs = [];
			let videoUrls = [];
			await videos.map(async (v, key) => {
				await (v.media?.video || []).map((l, key2) => {
					if (!langs.includes(l.language)) {
						langs.push(l.language);
					}
					if (l.language == "English") {
						videoUrls.push(l.url);
					}
				});
			});
			setUrls(videoUrls);
			setLangOptions(langs);
			setVideos(videos);
			if (videos.length >= 1) {
				// Resume where the learner left off: first chapter they haven't
				// finished yet (falls back to chapter 1 when none or all are done).
				const done = (progress.chapterProgress || []).map(String);
				let resumeIdx = videos.findIndex(
					(v) => !done.includes(String(v._id))
				);
				if (resumeIdx < 0) resumeIdx = 0;

				setActiveVideoIndex(resumeIdx);
				setLikeCount(videos[resumeIdx].likes.length);
				setActiveVideoUrl(videoUrls[resumeIdx]);
				setActiveVideoId(videos[resumeIdx]._id);
				setActiveVideoDescription(videos[resumeIdx].description);
				if (videos[resumeIdx].likes.includes(auth.getUserInfo()._id)) {
					setLike(true);
				}
			}

			setQuestions(
				quiz.questions.filter((q) => {
					return !progress.quizProgress.includes(q._id);
				})
			);

			setQuizID(quiz._id);
			setQuizProgress(progress.quizProgress);
			setVideoProgress(progress.chapterProgress);

			if (progress.chapterProgress.length == videos.length) {
				setLastVideo(true);
			}
			setResources(resources.resources);

			if (progress.isQuizFinished) {
				setQuizSubmitted(true);
			}
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		fetchData();

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);
	return (
		<IonPage>
			<div id="header_place2">
				<Header isOpaque={isOpaque} />
			</div>

			<div className="course-band">
				<div className="course-band-bg">
				<div className="center_wrapper course-band-inner">
					<button
						className="band-back"
						onClick={() => navigate(`/courses/${params.courseID}`)}
						aria-label="Back to course overview"
					>
						<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
							<path
								d="M19 12H5m0 0l7-7m-7 7l7 7"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</button>
					<h2 className="band-title">{course.name}</h2>
					{(() => {
						const totalSteps = videos.length + 1;
						const doneSteps =
							videoProgress.length + (quizSubmitted ? 1 : 0);
						const pct =
							videos.length > 0
								? Math.min(
										100,
										Math.round((doneSteps / totalSteps) * 100)
								  )
								: 0;
						return (
							<div className="band-progress">
								<span className="band-progress-label">
									{pct}% complete
								</span>
								<div className="band-track">
									<div
										className="band-fill"
										style={{ width: `${pct}%` }}
									/>
								</div>
							</div>
						);
					})()}
				</div>
				</div>
			</div>

			<div className="container center_wrapper">
				<div className="main-col">
					<div className="stage-tabs">
						{[
							{ key: "learn", label: "Learn", sub: "Watch, listen or view the lesson" },
							{ key: "practice", label: "Practice", sub: "Reinforce your learning" },
							{ key: "assess", label: "Assess", sub: "Test your understanding" },
							{ key: "complete", label: "Complete", sub: "Get certified" },
						].map((t, i) => {
							const isDone =
								(t.key === "learn" &&
									videos.length > 0 &&
									videoProgress.length >= videos.length) ||
								(t.key === "assess" && quizSubmitted) ||
								(t.key === "complete" &&
									quizSubmitted &&
									videos.length > 0 &&
									videoProgress.length >= videos.length);
							const isLocked =
								t.key === "assess" && !isQuizUnlocked && !quizSubmitted;
							const isActive = openStage === t.key;
							return (
								<React.Fragment key={t.key}>
									{i > 0 && <span className="tab-sep" aria-hidden="true"></span>}
									<button
										type="button"
										className={
											"stage-tab" +
											(isActive ? " active" : "") +
											(isDone ? " done" : "") +
											(isLocked ? " locked" : "")
										}
										onClick={() => selectStage(t.key)}
									>
										<span className="tab-marker">
											{isDone ? (
												"\u2713"
											) : isLocked ? (
												<FontAwesomeIcon icon={faLock} />
											) : (
												i + 1
											)}
										</span>
										<span className="tab-texts">
											<span className="tab-label">{t.label}</span>
											<span className="tab-sub">{t.sub}</span>
										</span>
									</button>
								</React.Fragment>
							);
						})}
					</div>

					{openStage === "learn" && (
						<div className="main-video">
							<div className="video active">
								{!lastVideo ? (
									<>
										{learnMode === "video" && (
											<div className="video-shell" ref={langRef}>
												<video
													src={mediaUrl(activeVideoUrl)}
													controls
													muted
													onEnded={(e) => handleEnd(e, activeVideoId)}
													onTimeUpdate={savePlaybackPos}
													onLoadedMetadata={restorePlaybackPos}
													controlsList="nodownload"
												></video>
												{langOptions.length > 0 && (
													<div className="lang-control">
														<button
															type="button"
															className="lang-chip"
															onClick={() =>
																setLangMenuOpen(!langMenuOpen)
															}
															aria-label="Video language"
														>
															<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
																<circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
																<path d="M3 12h18M12 3c2.5 2.4 3.8 5.6 3.8 9S14.5 18.6 12 21m0-18C9.5 5.4 8.2 8.6 8.2 12s1.3 6.6 3.8 9" stroke="currentColor" strokeWidth="1.6" />
															</svg>
															{selectedLang}
														</button>
														{langMenuOpen && (
															<div className="lang-menu">
																<div className="lang-menu-head">
																	Language
																</div>
																{langOptions.map((language, key) => (
																	<button
																		type="button"
																		key={key}
																		className={
																			"lang-item" +
																			(selectedLang === language
																				? " active"
																				: "")
																		}
																		onClick={() => {
																			handleLanguageChange({
																				target: { value: language },
																			});
																			setLangMenuOpen(false);
																		}}
																	>
																		<span className="lang-check">
																			{selectedLang === language
																				? "✓"
																				: ""}
																		</span>
																		{language}
																	</button>
																))}
															</div>
														)}
													</div>
												)}
											</div>
										)}
										{learnMode === "audio" && (
											<div className="audio-panel">
												<span className="audio-badge">
													<FontAwesomeIcon icon={faHeadphones} />
												</span>
												<p className="audio-title">
													{videos[activeVideoIndex]?.chapterTitle ||
														`Chapter ${activeVideoIndex + 1}`}{" "}
													— Audio lesson
												</p>
												<audio
													controls
													src={mediaUrl(
														(
															(
																videos[activeVideoIndex]?.media?.audio || []
															).find((a) => a.language === selectedLang) ||
															(videos[activeVideoIndex]?.media?.audio ||
																[])[0]
														)?.url || activeVideoUrl
													)}
													onEnded={(e) => handleEnd(e, activeVideoId)}
												></audio>
											</div>
										)}
										{learnMode === "slides" &&
											(() => {
												const apiSlides =
													videos[activeVideoIndex]?.media?.slides || [];
												// Until real decks are uploaded, fall back to the
												// branded demo deck for this chapter.
												const deck =
													apiSlides.length > 0
														? apiSlides.map((s) => ({
																src: mediaUrl(s.url),
																caption: s.caption || "",
														  }))
														: [1, 2, 3, 4].map((n) => ({
																src: `${process.env.PUBLIC_URL}/assets/slides/ch${
																	(activeVideoIndex % 6) + 1
																}_s${n}.svg`,
																caption: "",
														  }));
												const idx = Math.min(
													slideIndex,
													Math.max(0, deck.length - 1)
												);
												return (
													<div className="slides-panel">
														<div className="slides-stage">
															<img
																src={deck[idx].src}
																alt={deck[idx].caption}
															/>
															<button
																className="slide-arrow prev"
																onClick={() =>
																	setSlideIndex((i) => Math.max(0, i - 1))
																}
																disabled={idx === 0}
																aria-label="Previous slide"
															>
																<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
																	<path d="M19 12H5m0 0l6-6m-6 6l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																</svg>
															</button>
															<span className="slide-count">
																{idx + 1} / {deck.length}
															</span>
															<button
																className="slide-arrow next"
																onClick={() =>
																	setSlideIndex((i) =>
																		Math.min(deck.length - 1, i + 1)
																	)
																}
																disabled={idx === deck.length - 1}
																aria-label="Next slide"
															>
																<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
																	<path d="M5 12h14m0 0l-6-6m6 6l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
																</svg>
															</button>
														</div>
														{idx === deck.length - 1 && (
															<div className="slides-actions">
																<button
																	className="stage-cta"
																	onClick={markSlidesComplete}
																	disabled={markingComplete}
																>
																	{markingComplete
																		? "Saving…"
																		: "Mark chapter as complete"}
																</button>
																<span className="slides-note">
																	You've reached the last slide — mark this
																	chapter complete to continue.
																</span>
															</div>
														)}
													</div>
												);
											})()}
									</>
								) : (
									<div className="video-end">
										<h1 className="end-head">Good Job!</h1>
										<p className="end-sub">
											You have completed the {course.name} Video!
										</p>
										<p className="next-step" onClick={handleNextStep}>
											Next Step: {nextStepLabel(displayResources[0])}
										</p>
									</div>
								)}
								<div className="mode-card">
									<h4>Choose your learning mode</h4>
									<div className="mode-btns">
										<button
											className={
												"mode-btn" + (learnMode === "video" ? " active" : "")
											}
											onClick={() => selectMode("video")}
										>
											<span className="mode-icon">
												<FontAwesomeIcon icon={faPlay} />
											</span>
											Video
										</button>
										<button
											className={
												"mode-btn" + (learnMode === "audio" ? " active" : "")
											}
											onClick={() => selectMode("audio")}
										>
											<span className="mode-icon">
												<FontAwesomeIcon icon={faHeadphones} />
											</span>
											Audio
										</button>
										<button
											className={
												"mode-btn" + (learnMode === "slides" ? " active" : "")
											}
											onClick={() => selectMode("slides")}
										>
											<span className="mode-icon">
												<FontAwesomeIcon icon={faFileAlt} />
											</span>
											Slides
										</button>
									</div>
								</div>
							</div>
						</div>
					)}

					{openStage === "practice" && (
						<div className="practice-stage">
									{(() => {
										const deck =
											flashcards.length > 0
												? flashcards
												: practiceQuestions.map((pq) => ({
														front: pq.q,
														back: pq.a,
												  }));
										const i = Math.min(practiceIndex, deck.length - 1);
										const card = deck[i];
										return (
											<div className="flashcard-deck main-deck">
												<div
													className={"flashcard" + (flipped ? " flipped" : "")}
													onClick={() => {
														setFlipped((f) => !f);
														if (card._id) markFlashcardViewed(card._id);
													}}
												>
													<span className="flashcard-side">
														{flipped ? card.back : card.front}
													</span>
													<span className="flashcard-hint">
														{flipped ? "Tap to flip back" : "Tap to flip"}
													</span>
												</div>
												<div className="flashcard-nav">
													<button
														onClick={() => {
															setPracticeIndex((x) => Math.max(0, x - 1));
															setFlipped(false);
														}}
														disabled={i === 0}
													>
														‹
													</button>
													<span>
														{i + 1} / {deck.length}
													</span>
													<button
														onClick={() => {
															setPracticeIndex((x) =>
																Math.min(deck.length - 1, x + 1)
															);
															setFlipped(false);
														}}
														disabled={i >= deck.length - 1}
													>
														›
													</button>
												</div>
											</div>
										);
									})()}
								</div>
					)}

					{openStage === "assess" &&
						(isQuizUnlocked || quizSubmitted ? (
							<div className="main-quiz">
							{!quizSubmitted ? (
								<Carousel
									selectedItem={selectedQuestion}
									showArrows={false}
									showStatus={false}
									showIndicators={false}
									swipeable={false}
								>
									{questions.length > 0 &&
										questions.map((q, key) => {
											const totalQuestions =
												quizProgress.length + questions.length;
											const currentIndex = quizProgress.length + key;
											return (
												<div key={key} className="question">
													<form onSubmit={(e) => handleSubmit(e, q._id)}>
														<h3 className="q-no">Q. {key + 1}</h3>
														<h3 className="q-text">{q.question}</h3>
														<ul className="quiz-options">
															{q.options.map((opt, key2) => {
																const isCorrectOpt =
																	submitted && opt.value === correctAns;
																const isWrongOpt =
																	submitted &&
																	!isCorrect &&
																	opt.value === selectedOption &&
																	opt.value !== correctAns;
																const isSelected =
																	!submitted &&
																	selectedOption === opt.value;
																return (
																	<li
																		key={key2}
																		onClick={() =>
																			!submitted &&
																			setSelectedOption(opt.value)
																		}
																	>
																		<span
																			className={
																				"opt-box" +
																				(isCorrectOpt ? " correct" : "") +
																				(isWrongOpt ? " wrong" : "") +
																				(isSelected ? " selected" : "")
																			}
																		>
																			{isCorrectOpt
																				? "✓"
																				: isWrongOpt
																				? "✕"
																				: ""}
																		</span>
																		<span className="opt-label">
																			{opt.label}
																		</span>
																	</li>
																);
															})}
														</ul>
														<div className="ans-status">
															<span
																className={
																	"verdict " + (isCorrect ? "good" : "bad")
																}
															>
																{submitted
																	? isCorrect
																		? "Correct Answer"
																		: "Wrong Answer"
																	: ""}
															</span>
															{submitted ? (
																<span
																	onClick={() => handleNextQuestion()}
																	className="quiz-link"
																>
																	Next Question &gt;
																</span>
															) : (
																<button
																	className="quiz-link submit-answer"
																	type="submit"
																>
																	Submit Answer
																</button>
															)}
														</div>
														<div className="quiz-progress">
															{Array.from(
																{ length: totalQuestions },
																(_, i) => (
																	<span
																		key={i}
																		className={
																			"seg" +
																			(i <= currentIndex ? " fill" : "")
																		}
																	></span>
																)
															)}
														</div>
													</form>
												</div>
											);
										})}
								</Carousel>
							) : (
								<div className="course-end">
									<h1 className="end-head">Congratulations!</h1>
									<p className="end-sub">
										You have successfully completed this course.
									</p>
									<a
										href={`/certificate/${params.courseID}`}
										target="_blank"
										rel="noreferrer"
										className="cert-btn"
									>
										Download your Certificate
									</a>
									<div className="end-links">
										<a>Share your achievement</a>
										<span className="sep">|</span>
										<a>Feedback this course</a>
									</div>
								</div>
							)}
						</div>
						) : (
							<div className="locked-panel">
								<span className="locked-icon">
									<FontAwesomeIcon icon={faLock} />
								</span>
								<h3 className="locked-head">Assessment locked</h3>
								<p className="locked-sub">
									Watch all the chapters and go through the reference material
									below to unlock the final quiz.
								</p>
								<p className="progress-line">
									Chapters watched:{" "}
									<strong>
										{videoProgress.length}/{videos.length}
									</strong>
								</p>
							</div>
						))}

					{openStage === "complete" && (
						<div className="complete-panel">
							<h3 className="complete-head">Your course progress</h3>
							<p className="progress-line">
								Chapters watched:{" "}
								<strong>
									{videoProgress.length}/{videos.length}
								</strong>
							</p>
							<p className="progress-line">
								Quiz: <strong>{quizSubmitted ? "Completed" : "Pending"}</strong>
							</p>
							{nextChapterIdx !== -1 ? (
								<button className="stage-cta" onClick={goToNextChapter}>
									Continue: Chapter {nextChapterIdx + 1}
								</button>
							) : quizSubmitted ? (
								<a
									className="stage-cta"
									href={`/certificate/${params.courseID}`}
									target="_blank"
									rel="noreferrer"
								>
									Download your Certificate
								</a>
							) : (
								<p className="stage-note">
									All chapters done — finish the quiz in Assess to get
									certified.
								</p>
							)}
						</div>
					)}

					<div className="video-detail">
									<h3 className="title">{course.name}</h3>
									<div className="video-options">
										<span
											style={{ cursor: "pointer" }}
											onClick={handleLike}
											className="options"
										>
											<FontAwesomeIcon
												style={{ color: like ? "#293c74" : "gray" }}
												icon={faThumbsUp}
											/>{" "}
											{likeCount}{" "}
										</span>
										<span className="options share-wrap" ref={shareRef}>
											<span
												className="share-trigger"
												style={{ cursor: "pointer" }}
												onClick={() => setShareOpen(!shareOpen)}
											>
												<FontAwesomeIcon icon={faShare} /> Share
											</span>
											{shareOpen && (
												<div className="share-pop">
													<div className="share-pop-title">
														Share this course
													</div>
													<div className="share-pop-row">
														{shareTargets.map((t) => (
															<a
																key={t.name}
																className="share-app"
																href={t.href}
																target="_blank"
																rel="noopener noreferrer"
															>
																<span
																	className="share-app-icon"
																	style={{ background: t.color }}
																>
																	<FontAwesomeIcon icon={t.icon} />
																</span>
																<span className="share-app-name">
																	{t.name}
																</span>
															</a>
														))}
													</div>
													<div className="share-copy">
														<FontAwesomeIcon
															className="share-copy-link-icon"
															icon={faLink}
														/>
														<span className="share-copy-url">
															{shareUrl}
														</span>
														<button
															type="button"
															className={
																"share-copy-btn" +
																(shareCopied ? " copied" : "")
															}
															onClick={copyShareLink}
														>
															{shareCopied ? "Copied!" : "Copy"}
														</button>
													</div>
												</div>
											)}
										</span>
										<span
											style={{ cursor: "pointer" }}
											onClick={handleSave}
											className="options"
										>
											<FontAwesomeIcon
												style={{ color: save ? "#293c74" : "gray" }}
												icon={faBookmark}
											/>{" "}
											{save ? "Saved" : "Save"}{" "}
										</span>
									</div>
								</div>

								<p className="description">
									{course.description || activeVideoDescription}
								</p>
				</div>

				<div className="catalog-rail">
					{openStage === "practice" ? (
						<div className="rail-cue">
							<div className="cue-stack">
								<i></i>
								<i></i>
								<i></i>
								<i></i>
							</div>
							<span className="cue-title">Flash cards</span>
							<span className="cue-sub">
								Quickly reinforce key terms and concepts
							</span>
						</div>
					) : openStage === "assess" ? (
						<div className="rail-cue">
							<div className="cue-card q">?</div>
							<span className="cue-title">Quiz</span>
							<span className="cue-sub">
								Answer the questions to test what you have learned
							</span>
						</div>
					) : (
						<>
					<h4 className="catalog-head">Course content</h4>
					<div className="video-list-wrap">
						<div
							className="video-list"
							ref={videoListRef}
							onScroll={updateChapterFade}
						>
							{videos.map((video, key) => {
								return (
									<div
										key={key}
										className={
											"vid" +
											(key === activeVideoIndex &&
											!lastVideo &&
											openStage === "learn"
												? " active"
												: "")
										}
										onClick={() => {
											setQuiz(false);
											setOpenStage("learn");
											handleSelectionClick(video, key);
										}}
									>
										<video
											controlsList="nodownload"
											src={mediaUrl(urls[key])}
											poster={
												video.poster
													? mediaUrl(video.poster)
													: `${process.env.PUBLIC_URL}/assets/${
															chapterPosters[key % chapterPosters.length]
													  }`
											}
										></video>
										<h3 className="chapter-label">
											{video.chapterTitle || `Chapter ${key + 1}`}
										</h3>
									</div>
								);
							})}
						</div>
						<div
							className="white_grad"
							style={{ opacity: showGrad ? 1 : 0 }}
						></div>
					</div>
						</>
					)}
				</div>
			</div>

			<hr className="course-hr" />
			<section className="ref-section">
				<div className="center_wrapper" id="additional_reference">
					<h4 className="ref-section-head">Additional Reference Material</h4>
					{displayResources.map((r, key) => {
						const unlocked = isResourceUnlocked(key);
						const thumb = r.isDemo
							? `${process.env.PUBLIC_URL}/assets/ref_5s_methodology.svg`
							: mediaUrl(r.thumbnail);
						return (
							<div key={key} className="ref-course">
								<div>
									<img className="ref-img" src={thumb} alt="" />
								</div>
								<div className="ref-det">
									<h4 className="ref-head">{r.name}</h4>
									<p className="ref-content">{r.description}</p>
									<div className="ref-cta-row">
										{unlocked ? (
											r.isDemo ? (
												<button
													className="ref-cta"
													onClick={() => markResourceDone(key)}
												>
													{resourceCta(r)}
												</button>
											) : (
												<a
													target="_blank"
													rel="noreferrer"
													href={mediaUrl(r.url)}
													download={
														resourceCta(r) === "Download"
															? r.url.split("/").pop()
															: undefined
													}
													className="ref-cta"
													onClick={() => {
														track("resource_download", {
															course: params.courseID,
															meta: { resource: r._id, name: r.name },
														});
														markResourceDone(key);
													}}
												>
													{resourceCta(r)}
												</a>
											)
										) : (
											<>
												<button className="ref-cta locked" disabled>
													{resourceCta(r)}
												</button>
												<span className="lock-note">
													<FontAwesomeIcon icon={faLock} />
													Complete the previous step to unlock this.
												</span>
											</>
										)}
									</div>
								</div>
							</div>
						);
					})}
					{quiz ? (
						<div className="ref-course">
							<div>
								<img
									className="ref-img"
									src={`${process.env.PUBLIC_URL}/assets/ref_5s_methodology.svg`}
									alt=""
								/>
							</div>
							<div className="ref-det">
								<h4 className="ref-head">{course.name}</h4>
								<p className="ref-content">{course.description}</p>
								<div className="ref-cta-row">
									<button
										className="ref-cta"
										onClick={() => {
											setQuiz(false);
											setOpenStage("learn");
											window.scrollTo({ top: 0, behavior: "smooth" });
										}}
									>
										Watch Now
									</button>
								</div>
							</div>
						</div>
					) : (
						<div className="ref-course">
							<div>
								<img
									className="ref-img"
									src={`${process.env.PUBLIC_URL}/assets/ref_5s_methodology.svg`}
									alt=""
								/>
							</div>
							<div className="ref-det">
								<h4 className="ref-head">Worksheet MCQ</h4>
								<p className="ref-content">
									Now that you have absorbed a whole lot of information, you
									probably know more than you realize. Test your knowledge
									with this quiz.
								</p>
								<div className="ref-cta-row">
									{isQuizUnlocked ? (
										<button
											className="ref-cta"
											onClick={() => {
												setOpenStage("assess");
												setQuiz(true);
												window.scrollTo({ top: 0, behavior: "smooth" });
											}}
										>
											Get Started
										</button>
									) : (
										<>
											<button className="ref-cta locked" disabled>
												Get Started
											</button>
											<span className="lock-note">
												<FontAwesomeIcon icon={faLock} />
												Complete the previous step to unlock this.
											</span>
										</>
									)}
								</div>
							</div>
						</div>
					)}
				</div>
			</section>

			<div id="footer_place">
				<Footer />
			</div>
		</IonPage>
	);
};

export default ViewCourse;
